import { FC, PropsWithChildren } from "react";
import { Grid2 as Grid, InputLabel } from "@mui/material";

const CustomLabelInput: FC<
  PropsWithChildren<{
    label: string;
    id?: string;
    labelId?: string;
    error?: boolean;
    required?: boolean;
  }>
> = ({ children, label, id, labelId, error, required }) => {
  return (
    <Grid container spacing={1}>
      <Grid size={12}>
        <InputLabel shrink={false} htmlFor={id} id={labelId} error={error}>
          {label}
          {required && " *"}
        </InputLabel>
      </Grid>
      <Grid size={12}>{children}</Grid>
    </Grid>
  );
};

export default CustomLabelInput;
